import StopTwoTone from '@ant-design/icons/StopTwoTone'
import { Image, Typography } from 'antd'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import { useRolodexFileLS, useRolodexSignedURLs } from 'features/rolodex'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { GeckoTheme } from 'styles/GeckoTheme'

const { Text } = Typography

const ISOMETRIC_IMAGE_PATH = 'isometric.jpg'

const NoIsoImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 1rem;
  height: 100%;
`

const NoIsoImage: React.FC<{ indicationTitle: string }> = ({
  indicationTitle,
}) => {
  return (
    <NoIsoImageContainer>
      <StopTwoTone
        twoToneColor={GeckoTheme.colors.DeepSeaBlue}
        style={{ fontSize: '72px' }}
      />
      <Text>No Isometric image for {indicationTitle}</Text>
    </NoIsoImageContainer>
  )
}

const Container = styled.div`
  height: 100%;
`

export const Title = () => 'Isometric Image'
export const Width = '24rem'
export const CardView: FC<IndicationDetailCardProps> = () => {
  const { indication: indicationItem } = useIndicationData()
  const { url: imageUrl } = useRolodexSignedURLs(
    useMemo(
      () =>
        indicationItem
          ? [
              {
                entry_id: indicationItem.id,
                path: ISOMETRIC_IMAGE_PATH,
              },
            ]
          : [],
      [indicationItem]
    )
  )

  const files = useRolodexFileLS(
    useMemo(
      () =>
        indicationItem
          ? {
              entry_id: indicationItem.id,
              path: '/', // Return both files and directories at the root level
            }
          : undefined,
      [indicationItem]
    )
  )
  const hasIsoImage = useMemo(
    () =>
      files.fileRefs.find((fileRef) => fileRef.path === ISOMETRIC_IMAGE_PATH),
    [files.fileRefs]
  )

  return (
    <Container>
      {imageUrl && hasIsoImage ? (
        <Image src={imageUrl} alt={'Indication Isometric Image'} />
      ) : (
        <NoIsoImage indicationTitle={indicationItem?.title ?? 'Unknown'} />
      )}
    </Container>
  )
}
